import React from "react";
import Stack from "@vapor/react-material/Stack";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import VaporUploader from "@vapor/react-custom/VaporUploader";

export const ImportUploadPanel = ({
  t,
  importType,
  onUploadDesktopFile,
  onUploadMultiFile,
}) => {
  return (
    <Stack direction="row" sx={{ mb: 3 }}>
      <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
        <ExtendedTypography variant="titleSmall" color="primary.main">
          {t("anagrafica.ImportDesktop.uploadFile")}
        </ExtendedTypography>

        {importType === "aricdesktop" ? (
          <VaporUploader
            buttonVariant="contained"
            draggable
            multiple
            inputFileProps={{ accept: "text/plain, text/csv" }}
            label=""
            draggableText="Trascina qui il file prodotto ed esportato dalla versione desktop"
            dropText="Rilascia qui il file prodotto ed esportato dalla versione desktop"
            buttonLabel="Seleziona il file"
            onFileUpload={onUploadDesktopFile}
          />
        ) : null}

        {importType === "multi" ? (
          <VaporUploader
            buttonVariant="contained"
            draggable
            multiple
            inputFileProps={{ accept: "text/plain, text/csv" }}
            label=""
            draggableText="Trascina qui il file prodotto ed esportato da TS Studio Contabilità o Paghe"
            dropText="Rilascia qui il file prodotto ed esportato da TS Studio Contabilità o Paghe"
            buttonLabel="Seleziona il file"
            onFileUpload={onUploadMultiFile}
          />
        ) : null}
      </Stack>
    </Stack>
  );
};
